/** Nomes de tópicos Realtime. Privados: cmd_tela_*, fila_tela_*, platform_cmd, futebol_live_*. */
export const TOPICO_PLATAFORMA = 'platform_cmd';

// Minúsculo: o servidor publica em `cmd_tela_` / `fila_tela_` + uuid em minúsculas e a policy só aceita esse formato;
// /player/<UUID-MAIÚSCULO> carrega a tela e não pode gerar outro tópico.
export const topicoComandosTela = (telaId: string) => `cmd_tela_${telaId.toLowerCase()}`;
export const topicoStatusTela   = (telaId: string) => `canal_tela_${telaId}`;
export const topicoFilaTela     = (telaId: string) => `fila_tela_${telaId.toLowerCase()}`;
export const topicoFutebolLive  = (fixtureId: number | string) => `futebol_live_${fixtureId}`;
